<div *ngIf="!isLoading && featurePermissions['View Students']" class="padding-sm">
	<mat-card-header>
		<mat-card-title *ngIf="studentName.length > 0" class="h5">
			{{studentName}} {{regions}} <span class="danger h5">{{merged}} {{terminated}}</span>
			<span class="margin-left-sm" *ngIf="isMerged || merged"><view-children-merge-tree-btn
					[studentId]="studentId" [studentMsdNumber]="msdNumber"></view-children-merge-tree-btn></span>
			<span class="align-btn margin-left-sm">
				<button mat-raised-button
					*ngIf="featurePermissions['Edit Students'] && !editing && editableTabs[currentTab]" color="primary"
					(click)="toggleEdit()">Edit</button>
				<confirm-popover [type]="'submit'" [buttonTxt]="'Stop Editing'"
					[popoverMsg]="'Unsaved changes will be lost. Continue?'"
					*ngIf="featurePermissions['Edit Students'] && editing" [color]="'warn'" (onConfirm)="toggleEdit()">
				</confirm-popover>
			</span>
		</mat-card-title>
	</mat-card-header>
	<h1 *ngIf="studentName.length === 0">
		<mat-icon>
			<mat-spinner diameter="20"> </mat-spinner>
		</mat-icon>
	</h1>
	<mat-tab-group #tabs dynamicHeight>
		<mat-tab label="Demographic">
			<ng-template matTabContent>
				<div class="tab-padding">
					<edit-child-demographic [studentId]="studentId" [(editing)]="editing"
						(editingChange)="editingChange(editing)">
					</edit-child-demographic>
				</div>
			</ng-template>
		</mat-tab>
		<mat-tab label="Address Info">
			<ng-template matTabContent>
				<div class="tab-padding">
					<address-info [(editing)]="editing" (editingChange)="editingChange(editing)">

					</address-info>
				</div>
			</ng-template>
		</mat-tab>
		<mat-tab label="Enrollment Info">
			<ng-template matTabContent>
				<div class="tab-padding">
					<edit-child-enrollment [studentId]="studentId" [(editing)]="editing"
						(editingChange)="editingChange(editing)"></edit-child-enrollment>
				</div>
			</ng-template>
		</mat-tab>
		<mat-tab label="Eligibility Status">
			<ng-template matTabContent>
				<div class="tab-padding">
					<edit-child-eligibility-status [studentId]="studentId"></edit-child-eligibility-status>
				</div>
			</ng-template>
		</mat-tab>
		<mat-tab label="Move History">
			<ng-template matTabContent>
				<div class="tab-padding">
					<edit-child-move-history [studentId]="studentId"></edit-child-move-history>
				</div>
			</ng-template>
		</mat-tab>
		<mat-tab label="Service Participation">
			<ng-template matTabContent>
				<div class="tab-padding">
					<edit-child-service-participation [studentId]="studentId" [(editing)]="editing"
						(editingChange)="editingChange(editing)"></edit-child-service-participation>
				</div>
			</ng-template>
		</mat-tab>
		<mat-tab label="Communication Events" >
			<ng-template matTabContent>
				<div class="tab-padding">
					<app-communication-event [studentId]="studentId" [editing]="editing">

					</app-communication-event>
				</div>
			</ng-template>
		</mat-tab>
		<mat-tab label="Course History" >
			<ng-template matTabContent>
				<div class="tab-padding">
					<app-course-history [studentId]="studentId" [editing]="editing">

					</app-course-history>
				</div>
			</ng-template>
		</mat-tab>
		<mat-tab label="INA/ILP" >
			<ng-template matTabContent>
				<div class="tab-padding">
					<app-ina [studentId]="studentId" [editing]="editing">
					</app-ina>
				</div>
			</ng-template>
		</mat-tab>
	</mat-tab-group>
</div>
<div *ngIf="featurePermissions && !featurePermissions['View Students']">

</div>